import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { CrudService } from '@mango/core';
import { Observable } from 'rxjs';
import { User } from './user';
import { SendActivationCodeResponse } from './send-activation-code-response';
import { SendMultipleActivationCodeResponse } from './request-multiple-activations/send-multiple-activation-code-response';

@Injectable()
export class UserService extends CrudService<User> {

    constructor(injector: Injector) { super(User, injector); }
    
    sendActivationCode(id: number) : Observable<SendActivationCodeResponse> {
        return this.http.post(`/api/connect/sendActivationCode?id=${id}`, {}) as Observable<SendActivationCodeResponse>;
    }

    sendForgotPassword(email: string) : Observable<SendActivationCodeResponse> {
        
        return this.http.post(`/api/connect/ForgotPassword?loginId=${email}`, {}) as Observable<SendActivationCodeResponse>;
    }

}
